module.exports = __webpack_public_path__ + "static/media/delete-disabled.f7e1feef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/delete-disabled.svg
// module id = 839
// module chunks = 0